import React, { useState } from "react";
import { siteConfig } from "../../config/siteConfig";

const Navbar = ({ onLoginClick, onRegisterClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { brand, hero } = siteConfig;

  const navLinks = [
    { href: "#features", label: "Características" },
    { href: "#pricing", label: "Precios" },
    { href: "#testimonials", label: "Qué incluye" },
    { href: "#faq", label: "FAQ" },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white/80 backdrop-blur-md z-50 border-b border-slate-200/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center gap-3">
            <div className="bg-gradient-to-br from-emerald-600 to-teal-700 p-2.5 rounded-xl shadow-lg shadow-emerald-200/50">
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
            </div>
            <div className="flex flex-col leading-none">
              <span className="text-2xl font-extrabold tracking-tight bg-gradient-to-r from-slate-900 to-slate-700 bg-clip-text text-transparent">
                {brand.namePrefix}
                <span className="text-emerald-600">{brand.nameSuffix}</span>
              </span>
              {brand.subBrand && (
                <span className="text-[12px] font-bold text-emerald-600 mt-0.5 tracking-tighter">
                  {brand.subBrand}
                </span>
              )}
            </div>
          </div>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link, idx) => (
              <a key={idx} href={link.href} className="text-sm font-semibold text-slate-600 hover:text-emerald-600 transition-colors">
                {link.label}
              </a>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-4">
            <button onClick={onLoginClick} className="px-5 py-2.5 text-sm font-bold text-slate-700 hover:text-emerald-600 transition-colors">
              Iniciar sesión
            </button>
            <button onClick={onRegisterClick} className="px-5 py-2.5 bg-gradient-to-r from-emerald-600 to-teal-600 text-white text-sm font-bold rounded-xl shadow-lg shadow-emerald-200 hover:shadow-xl hover:scale-105 transition-all">
              {hero.primaryCta}
            </button>
          </div>

          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden p-2 rounded-lg hover:bg-slate-100 transition-colors">
            <svg className="w-6 h-6 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-slate-200 animate-slideDown">
            <div className="flex flex-col gap-4">
              {navLinks.map((link, idx) => (
                <a key={idx} href={link.href} className="text-sm font-semibold text-slate-600 hover:text-emerald-600 py-2">
                  {link.label}
                </a>
              ))}
              <div className="flex flex-col gap-3 pt-2">
                <button onClick={onLoginClick} className="px-4 py-2.5 text-sm font-bold text-slate-700 border border-slate-200 rounded-xl hover:bg-slate-50">
                  Iniciar sesión
                </button>
                <button onClick={onRegisterClick} className="px-4 py-2.5 bg-gradient-to-r from-emerald-600 to-teal-600 text-white text-sm font-bold rounded-xl">
                  {hero.primaryCta}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
